import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text, TextButton} from 'wix-ui-tpa/cssVars'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {usePageStateSelector} from '../../../../hooks/state'
import {isCouponInputVisible} from '../../../../selectors/checkout-options'
import {isMembershipSelectorVisible} from '../../../../selectors/paid-plans'
import {getInvoice} from '../../../../selectors/placed-order'
import {CouponInput} from '../../../summary/coupon-input'
import {MembershipDropdown} from '../../../summary/membership-dropdown'
import s from './checkout-summary.scss'
import {classes} from './checkout-summary.st.css'
import {CheckoutSummaryProps} from './interfaces'

export const CheckoutSummary = ({onViewAllItems, currentStep}: CheckoutSummaryProps) => {
  const {t} = useTranslation()
  const {grandTotal} = usePageStateSelector(getInvoice)
  const {getFormattedMoney} = useCurrencyFormatter()
  const couponInputVisible = usePageStateSelector(isCouponInputVisible)
  const membershipSelectorVisible = usePageStateSelector(isMembershipSelectorVisible)

  return (
    <div className={s.container}>
      {couponInputVisible && <CouponInput currentStep={currentStep} mobile />}
      {membershipSelectorVisible && <MembershipDropdown currentStep={currentStep} mobile />}
      <div className={s.summary}>
        <div className={classNames(s.row, classes.details)}>
          <Text>{t('mobile.couponForm.title')}</Text>
          <TextButton onClick={onViewAllItems} data-hook={DH.SHOW_SUMMARY_BUTTON}>
            {t('mobile.summary.showTickets')}
          </TextButton>
        </div>
        <div className={classNames(s.row, classes.total)} data-hook={DH.CHECKOUT_SUMMARY_TOTAL}>
          <Text>{t('mobile.ticketsPicker.total')}</Text>
          <Text>{getFormattedMoney(grandTotal)}</Text>
        </div>
      </div>
    </div>
  )
}
